(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function cscrSubmit(e) {
    e.preventDefault();
    var form = e.target;
    form.style.display = 'none';
    document.getElementById('cscrThanks').style.display = 'block';
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (() => {
    const REVIEW_SELECTORS =
      '.jdgm-widget, .spr-container, .yotpo, .okeReviews, [class*="product-reviews"], [id*="product-reviews"] , [class="product-information__reviews"]';

    const relocate = () => {
      document.querySelectorAll('.product-information__grid').forEach((grid) => {
        const widget = grid.querySelector(REVIEW_SELECTORS);
        if (!widget) return;

        const host = widget.closest('.shopify-app-block, .shopify-block') || widget;
        if (!grid.contains(host) || host.parentElement === grid.parentElement) return;

        try {
          grid.insertAdjacentElement('afterend', host);
        } catch (error) {
          console.warn('[product-information] review relocation failed', error);
        }
      });
    };

    const start = () => {
      relocate();
      const grid = document.querySelector('.product-information__grid');
      if (!grid) return;
      const observer = new MutationObserver(() => relocate());
      observer.observe(grid, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 8000);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();
})();
